export enum PenaltyAttribute {
  Retaken = 3036,
}
